import React, { useState } from "react";
import { Filter, Search, X, Plus } from "lucide-react";

const inputClasses =
  "w-full rounded-lg border border-[#E5E7EB] bg-white px-3 py-2 text-sm text-[#1F2937] focus:outline-none focus:ring-2 focus:ring-[#DC2626]/30 focus:border-[#DC2626] transition-colors";

export default function ECGFilters({ customers, onApply, onClear, activeCount }) {
  const [showPanel, setShowPanel] = useState(false);
  const [draft, setDraft] = useState({
    customer: "",
    status: "",
    gender: "",
    test_date: "",
    search: "",
  });

  const handleChange = (key, value) => {
    setDraft((prev) => ({ ...prev, [key]: value }));
  };

  const handleApply = () => {
    onApply(draft);
    setShowPanel(false);
  };

  const handleClear = () => {
    setDraft({ customer: "", status: "", gender: "", test_date: "", search: "" });
    onClear();
  };

  const handleSearchKeyDown = (e) => {
    if (e.key === "Enter") onApply(draft);
  };

  const panelActiveCount = ["customer", "status", "gender", "test_date"].filter(
    (k) => draft[k]
  ).length;
  const badgeCount = typeof activeCount === "number" ? activeCount : panelActiveCount;

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:items-center gap-2">
        <div className="relative flex-1">
          <Search className="w-4 h-4 text-[#9CA3AF] absolute left-3 top-1/2 -translate-y-1/2" />
          <input
            type="text"
            placeholder="Search by Patient ID or Name..."
            className={`${inputClasses} pl-9`}
            value={draft.search}
            onChange={(e) => handleChange("search", e.target.value)}
            onKeyDown={handleSearchKeyDown}
          />
        </div>

        <button
          onClick={() => setShowPanel((c) => !c)}
          className="inline-flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-medium rounded-lg border border-[#E5E7EB] bg-white text-[#374151] hover:bg-[#F9FAFB] transition-colors shrink-0"
        >
          <Filter className="w-4 h-4" />
          Filter
          {badgeCount > 0 && (
            <span className="ml-1 inline-flex items-center rounded-full bg-[#FEF2F2] text-[#B91C1C] text-xs font-medium px-2 py-0.5 border border-[#FCA5A5]">
              {badgeCount}
            </span>
          )}
        </button>

        {/* Add Patient: intentionally disabled for now — no backend/route wired yet */}
        {/* <button
          type="button"
          disabled
          title="Coming soon"
          className="inline-flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-medium rounded-lg bg-[#F3F4F6] text-[#9CA3AF] cursor-not-allowed shrink-0"
        >
          <Plus className="w-4 h-4" />
          Add Patient
        </button> */}
      </div>

      {showPanel && (
        <div className="mt-3 bg-white border border-[#E5E7EB] rounded-xl shadow-sm p-4 sm:p-5">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
            <div>
              <label className="block text-xs font-medium text-[#6B7280] mb-1">Customer</label>
              <select
                className={inputClasses}
                value={draft.customer}
                onChange={(e) => handleChange("customer", e.target.value)}
              >
                <option value="">All Customers</option>
                {(customers || []).map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.name}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="block text-xs font-medium text-[#6B7280] mb-1">Status</label>
              <select
                className={inputClasses}
                value={draft.status}
                onChange={(e) => handleChange("status", e.target.value)}
              >
                <option value="">All Status</option>
                <option value="pending">Pending</option>
                <option value="reported">Reported</option>
              </select>
            </div>

            <div>
              <label className="block text-xs font-medium text-[#6B7280] mb-1">Gender</label>
              <select
                className={inputClasses}
                value={draft.gender}
                onChange={(e) => handleChange("gender", e.target.value)}
              >
                <option value="">All Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div>
              <label className="block text-xs font-medium text-[#6B7280] mb-1">Test Date</label>
              <input
                type="date"
                className={inputClasses}
                value={draft.test_date}
                onChange={(e) => handleChange("test_date", e.target.value)}
              />
            </div>
          </div>

          <div className="flex items-center justify-end gap-2 mt-4">
            <button
              onClick={handleClear}
              className="inline-flex items-center gap-1.5 px-4 py-2 text-sm font-medium rounded-lg border border-[#E5E7EB] text-[#374151] hover:bg-[#F9FAFB] transition-colors"
            >
              <X className="w-4 h-4" />
              Clear Filters
            </button>
            <button
              onClick={handleApply}
              className="inline-flex items-center gap-1.5 px-4 py-2 text-sm font-medium rounded-lg bg-[#DC2626] text-white hover:bg-[#B91C1C] transition-colors"
            >
              <Filter className="w-4 h-4" />
              Apply Filters
            </button>
          </div>
        </div>
      )}
    </div>
  );
}